import React, { useEffect, useState } from "react";
import {
  getMatchingDatePreset,
  getPresetDateRange,
} from "utils/dateFilterUtils";

const CREATED_DATE_OPTIONS = [
  { label: "Today", value: "today" },
  { label: "Last 7 Days", value: "last7Days" },
  { label: "This Month", value: "thisMonth" },
  { label: "This Quarter", value: "thisQuarter" },
  { label: "Last 6 Months", value: "last6Months" },
  { label: "Custom", value: "custom" },
];

const CreatedDateFilter = ({ handleInputChange, appliedFilters }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [error, setError] = useState("");

  const handleOptionChange = (value) => {
    setSelectedOption(value);
    setError("");

    if (value !== "custom") {
      const range = getPresetDateRange(value);

      handleInputChange(
        "createdDate",
        {
          startDate: range.startDate,
          endDate: range.endDate,
          preset: value,
        },
        false,
      );
    }
  };

  const applyCustomRange = () => {
    setError("");

    if (!startDate || !endDate) {
      setError("Please select both start and end date.");
      return;
    }

    if (new Date(endDate) < new Date(startDate)) {
      setError("End date cannot be before start date.");
      return;
    }

    handleInputChange(
      "createdDate",
      {
        startDate,
        endDate,
      },
      false,
    );
  };

  useEffect(() => {
    if (!appliedFilters?.createdDate) {
      setSelectedOption("");
      setStartDate("");
      setEndDate("");
      return;
    }

    const {
      startDate: appliedStartDate = "",
      endDate: appliedEndDate = "",
      preset: appliedPreset = "",
    } = appliedFilters.createdDate;

    const matchedPreset = CREATED_DATE_OPTIONS.some(
      (option) => option.value === appliedPreset && option.value !== "custom",
    )
      ? appliedPreset
      : getMatchingDatePreset({
          startDate: appliedStartDate,
          endDate: appliedEndDate,
        });

    setSelectedOption(matchedPreset || "custom");
    setStartDate(appliedStartDate);
    setEndDate(appliedEndDate);
  }, [appliedFilters?.createdDate]);

  return (
    <div className="flex flex-col gap-1 px-3 py-2 text-xs">
      {CREATED_DATE_OPTIONS.map((option) => (
        <label
          key={option.value}
          className="flex cursor-pointer items-center gap-2 rounded-md px-1 py-1 text-[#303026] hover:bg-[#FFF4EE]"
        >
          <input
            type="radio"
            name="createdDate"
            checked={selectedOption === option.value}
            onChange={() => handleOptionChange(option.value)}
            className="h-4 w-4 border-gray-300 text-[#E95420] focus:ring-[#E95420]"
          />
          {option.label}
        </label>
      ))}

      {selectedOption === "custom" && (
        <div className="mt-2 flex flex-col gap-2">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="rounded-md border border-[#DADAD0] px-2 py-1.5 text-xs focus:border-[#E95420] focus:ring-[#E95420]"
          />

          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="rounded-md border border-[#DADAD0] px-2 py-1.5 text-xs focus:border-[#E95420] focus:ring-[#E95420]"
          />

          <button
            type="button"
            onClick={applyCustomRange}
            className="rounded-md border border-[#1E1E08] bg-white px-3 py-1.5 text-xs font-semibold text-[#1E1E08] hover:bg-[#F2F2EA]"
          >
            Apply
          </button>

          {error && (
            <p className="text-red-500 text-xs">
              {error}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default CreatedDateFilter;
